var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasCode)?_c('login',{on:{"has-code":function($event){_vm.hasCode = true}}}):_vm._e(),(_vm.hasCode)?_c('Code',{on:{"request-code":function($event){_vm.hasCode = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }